
import { CustomizableWatch } from '../../../mocks/customizable-watches';

interface ProductWatchPreviewProps {
  watchProduct: CustomizableWatch;
  selectedOptions: Record<string, string>;
  activeTab: string;
}

export default function ProductWatchPreview({
  watchProduct,
  selectedOptions,
  activeTab,
}: ProductWatchPreviewProps) {
  const getCategoryLabel = (key: string): string => {
    const labels: Record<string, string> = {
      caseMaterial: 'Case Material',
      bezelType: 'Bezel Type',
      dialColor: 'Dial Color',
      hands: 'Hands Style',
      braceletStrap: 'Bracelet/Strap',
      movement: 'Movement',
      pushers: 'Pushers',
      subdialLayout: 'Subdial Layout',
      crownGuards: 'Crown Guards',
      caseShape: 'Case Shape',
      braceletIntegration: 'Bracelet',
      dayDisplay: 'Day Display',
      engraving: 'Engraving',
    };
    return labels[key] || key;
  };

  const formatValue = (value: string): string => {
    return value.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  };

  const hasSelections = Object.values(selectedOptions).some(
    (v) => v && v.length > 0,
  );

  return (
    <div className="sticky top-24">
      <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 shadow-xl">
        <div className="aspect-square bg-white rounded-xl overflow-hidden shadow-lg mb-6">
          <img
            src={watchProduct.image}
            alt={watchProduct.name}
            title={`Custom ${watchProduct.shortName} watch design`}
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div className="space-y-3 bg-white rounded-xl p-6 shadow-md">
          <h3 className="font-serif text-xl font-semibold text-gray-900 mb-4">
            Your {watchProduct.shortName} Design
          </h3>

          {hasSelections ? (
            <>
              {Object.entries(selectedOptions).map(([key, value]) => {
                if (!value || key === 'engraving') return null;
                return (
                  <div key={key} className="flex justify-between text-sm">
                    <span className="text-gray-600">{getCategoryLabel(key)}:</span>
                    <span className="font-medium text-gray-900">{formatValue(value)}</span>
                  </div>
                );
              })}
              {selectedOptions.engraving && (
                <div className="flex justify-between text-sm pt-3 border-t border-gray-200">
                  <span className="text-gray-600">Engraving:</span>
                  <span className="font-medium text-gray-900">{selectedOptions.engraving}</span>
                </div>
              )}
            </>
          ) : (
            <p className="text-sm text-gray-500 text-center py-4">
              Start selecting options to see your design
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
